module.exports = __webpack_public_path__ + "static/img/icon-eva1.3a7baff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva1.jpg
// module id = K1UL
// module chunks = 21